import { ClipboardList, PencilRuler, Truck } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    n: "01",
    title: "Request a Quote",
    desc: "Tell us about your event — date, location, guest count, and the vibe you're after. We'll respond with a tailored proposal.",
  },
  {
    icon: PencilRuler,
    n: "02",
    title: "Design Your Menu",
    desc: "We collaborate on a custom menu — signature drinks, paninis, and pastries — sized to your guest count and timeline.",
  },
  {
    icon: Truck,
    n: "03",
    title: "We Arrive & Serve",
    desc: "Our team handles setup, full barista service, and cleanup. You enjoy the event while we pour the coffee.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-24 md:py-32 bg-[#F2EBE1]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-4">
            Simple & Seamless
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2C2621] tracking-tight">
            How it works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 relative">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${s.n}`}
                className="relative text-center md:text-left"
              >
                <div className="flex items-center justify-center md:justify-start gap-4 mb-5">
                  <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#8B5E3C] text-white">
                    <Icon size={24} strokeWidth={1.5} />
                  </span>
                  <span className="font-serif-display text-5xl text-[#D4C3B3]">{s.n}</span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl font-semibold text-[#2C2621] mb-3">
                  {s.title}
                </h3>
                <p className="text-[#594D42] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
